import { CompletedChallengeStatus } from '../../../../utils/challenge-utils';
import styles from './allChallenges.module.css';

type ChallengeStatusTagProps = {
  status: CompletedChallengeStatus;
  onClaim?: () => void;
};

const VARIANT_CLASS: Record<Exclude<CompletedChallengeStatus, 'claim'>['variant'], string> = {
  success: styles.statusSuccess,
  caution: styles.statusCaution,
  warning: styles.statusWarning,
  info: styles.statusInfo,
  critical: styles.statusCritical,
};

export default function ChallengeStatusTag({ status, onClaim }: ChallengeStatusTagProps) {
  if (status === 'claim') {
    return (
      <button type="button" className={styles.claimLink} onClick={onClaim}>
        Claim reward
      </button>
    );
  }

  return <span className={`${styles.statusTag} ${VARIANT_CLASS[status.variant]}`}>{status.label}</span>;
}
